import React, {useEffect, useState} from "react";
import {
    Container,
    Dropdown,
    Input,
    Button,
    Form,
    TextArea,
    Header,
} from "semantic-ui-react";
import {RootState} from "../model";
import {connect} from "react-redux";
import Template from "./Template";
import {useActions} from "../redux/actions";
import * as practiceActions from "../redux/actions/practice";
import * as openDentalActions from "../redux/actions/openDental";

const methodOptions = ["GET", "POST", "PUT"].map((m) => ({
    key: m,
    value: m,
    text: m,
}));

function ManualApiModule() {
    const initialState: any = {
        practiceOpts: [],
    };
    const initialForm: any = {
        url: '',
        body: '',
        method: '',
        practices: []
    }
    const [state, setState] = useState(initialState);
    const [form, setFormData] = useState(initialForm);
    const [responseText, setResponseText] = useState<any>("");

    const practiceAction = useActions(practiceActions);
    const openDentalAction = useActions(openDentalActions);

    useEffect(() => {
        setTimeout(() => {
            const practiceOpts: any = [];
            practiceAction.getAllPractices().then((practices: any) => {
                practices && practices.forEach((item: any) => {
                    const practice = item.practice;
                    practiceOpts.push({
                        key: practice.id,
                        value: practice.id,
                        text: practice.practice
                    })
                })
            })
            setState({
                ...state,
                practiceOpts: practiceOpts
            })
        }, 500);
    }, []);

    const submitHandler = () => {
        if(!form || !form.method || !form.url || !form.practices) {
            alert("Please fill all required fields.");
            return;
        }
        openDentalAction.manualApiCall(form)
            .then((res: any) => {
                setResponseText(res)
            }).catch((err: any) => {
                setResponseText(err)
             })
    }
    return (
        <Template activeLink="api-request-module">
            <Container>
                <Header as="h2">
                    <Header.Content>API Request Module</Header.Content>
                </Header>

                <Form className="mb20">
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Practices <span className={'red'}>*</span> </label>
                            <Dropdown
                                fluid={true}
                                selection={true}
                                multiple={true}
                                options={state.practiceOpts}
                                onChange={(_, data) => {
                                    setFormData({...form, practices: data.value as string})
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Method <span className={'red'}>*</span></label>
                            <Dropdown
                                fluid
                                selection
                                options={methodOptions}
                                value={form.method}
                                onChange={(_, data) => setFormData({...form, method: data.value as string})}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Request URL <span className={'red'}>*</span></label>
                            <Input
                                label={'http://practice.smd.aws.cdp.dental:30223/api/v1'}
                                fluid
                                placeholder="/definitions"
                                value={form.url}
                                onChange={(e) => setFormData({...form, url: e.target.value})}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>&nbsp;</label>
                            <Button
                                primary
                                fluid
                                onClick={() => submitHandler()}
                            >
                                Send
                            </Button>
                        </Form.Field>
                    </Form.Group>

                    <Form.Field>
                        <label>Body</label>
                        <TextArea
                            placeholder='{"key":"value"}'
                            value={form.body}
                            onChange={(e) => setFormData({...form, body: e.target.value})}
                            rows={10}
                        />
                    </Form.Field>
                </Form>

                <div className="ui card" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    <div className="content">
                    <Header as="h4">Response</Header>
                    {responseText ?
                        <pre>
                          {JSON.stringify(responseText, null, 2)}
                        </pre>
                        : <pre>{"Response will appear here..."}</pre>}
                    </div>
                </div>
            </Container>
        </Template>
    );
}

function mapStateToProps(state: RootState) {
    return {
        auth: state.auth,
        allPracticeList: state.practice.allPracticeList,
        loader: state.app.loader,
    };
}

export default connect(mapStateToProps)(ManualApiModule);
